module.exports = __webpack_public_path__ + "img/49-r.3c0c5136.png";